import { type Event, type EventDispatchProps, type SetEventsProps } from 'src/types'

// consider adding props that last from game to game
const setEvents = ({ events }: SetEventsProps) => events

const addEvent = (events: Record<string, Event>, { event }: EventDispatchProps) => ({
  ...events,
  [event.id]: event
})

export const reducer = (events: Record<string, Event>, action: EventDispatchProps) => {
  switch (action.type) {
    case 'SET_EVENTS':
      return setEvents(action)
    case 'ADD_EVENT':
      return addEvent(events, action)
    default:
      return events
  }
}
